import styles from "./ImageComponent.module.css";
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ImageManagementModal from "./modal/ImageManagementModal";
import { pictureCaption } from './common/pictureCaption';

function ImageComponent(props) {
    const { tmpKey } = useParams();
    const [urls, setUrls] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [draftOpinion, setDraftOpinion] = useState(""); // 사용되지 않더라도 기존 코드 유지
    const [endPoint, setEndPoint] = useState("/api/getImages");

    // ✅ [추가됨] 현재 보여줄 이미지 주소를 담을 state
    const [currentImageSrc, setCurrentImageSrc] = useState(null);

    // 1. 데이터 가져오기
    useEffect(() => {
        const fetchData = async () => {
            let apiEndpoint = "/api/getImages";
            if (props.type !== 'Image') {
                setEndPoint("/api/getPathologyImages");
                apiEndpoint = "/api/getPathologyImages";
            }

            const reqOption = {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    name: tmpKey
                }),
            };

            try {
                const response = await fetch(apiEndpoint, reqOption);
                const data = await response.json();

                // ✅ [수정됨] 데이터를 새로 받아오면 urls 업데이트 + 인덱스 0으로 초기화
                setUrls(data);
                setCurrentIndex(0);

            } catch (error) {
                console.error('Failed to fetch images:', error);
                // 에러 발생 시에도 안전하게 초기화
                setUrls([]);
                setCurrentIndex(0);
            }
        };

        fetchData();
    }, [tmpKey, props.type]); // tmpKey(샘플명)나 type이 바뀌면 실행됨

    // ✅ [수정됨] 이미지 URL 생성 및 메모리 해제 최적화 (핵심!)
    // currentIndex나 urls가 변경될 때만 Blob URL을 새로 생성합니다.
    useEffect(() => {
        let objectUrl = null;

        if (urls.length > 0 && urls[currentIndex]?.picture?.data) {
            try {
                const imageBuffer = urls[currentIndex].picture.data;
                // 서버에서 JPG로 변환해서 준다고 가정하에 type 지정
                const newBlob = new Blob([new Uint8Array(imageBuffer)], { type: 'image/jpeg' });
                objectUrl = URL.createObjectURL(newBlob);
                setCurrentImageSrc(objectUrl);
            } catch (e) {
                console.error("Image Blob creation failed:", e);
                setCurrentImageSrc(null);
            }
        } else {
            setCurrentImageSrc(null);
        }

        // Cleanup: 컴포넌트가 언마운트되거나 이미지가 바뀔 때 기존 URL 메모리 해제
        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [urls, currentIndex]);

    // 모달 관련 함수들 (기존 로직 동일)
    const handleEditClick = () => {
        setIsEditModalOpen(!isEditModalOpen);
    };

    const closeDraftModal = () => {
        setIsEditModalOpen(false);
    };

    const saveDraft = (draft) => {
        setDraftOpinion(draft);
        setIsEditModalOpen(false);
    };

    // 이미지 이름 변경 로직 (기존 로직 동일)
    // 캡션 규칙은 공용 함수 하나로 — 배율·같은 조건 사진 번호 (2) 를 이름 어디에 있어도 읽는다
    const nameChange = (name) => pictureCaption(name);

    // 이미지 네비게이션 함수 (기존 로직 동일)
    const nextImage = () => {
        setCurrentIndex(currentIndex < urls.length - 1 ? currentIndex + 1 : currentIndex);
    };

    const prevImage = () => {
        setCurrentIndex(currentIndex > 0 ? currentIndex - 1 : currentIndex);
    };

    return (
        <div className={styles.outBox}>
            <div className={styles.title}>
                <span>{props.type === 'Image' ? 'PDO Image' : 'PDO Pathology'}</span>
                <span className={styles.editButton} onClick={handleEditClick}>
                    edit
                </span>
                {isEditModalOpen &&
                    <ImageManagementModal onClose={closeDraftModal} onSubmit={saveDraft} endPoint={endPoint} />
                }
            </div>
            <div className={styles.imageContainer}>
                {urls.length > 0 && (
                    <>
                        <button onClick={prevImage}>&lt;</button>

                        <div className={styles.imageWrapper}>
                            {currentImageSrc ? (
                                <img
                                    src={currentImageSrc}
                                    alt="Displayed content"
                                    className={styles.previewImage}
                                />
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%', color: '#9ca3af' }}>
                                    Loading...
                                </div>
                            )}
                        </div>

                        <button onClick={nextImage}>&gt;</button>
                    </>
                )}
            </div>
            <div className={styles.pictureName}>
                {nameChange(urls[currentIndex]?.picture_key)}
            </div>
        </div>
    );
}

export default ImageComponent;